import React, { Component } from 'react';
import { Image as KonvaImage } from 'react-konva';
import _remove from 'lodash/remove';
import _uniq from 'lodash/uniq';

const urltool = require('url');
//const cache = {};

class CachedImage extends Component {
  ref = null;

  state = {
    image: null
  };

  constructor(props) {
    super(props);
    this.load = this.load.bind(this);

    if (!global.imageCache) {
      global.imageCache = {};
    }

    if (!global.imageLoadingState) {
      global.imageLoadingState = [];
    }
  }

  load(src) {
    let url = src;
    let img = global.imageCache[url] || false;

    // if (img) {
    //   return this.setState({image: img});
    // }

    img = global.imageCache[url] = new Image();

    if (this.props.cors || false) {
      img.crossOrigin = 'anonymous';
      //img.setAttribute('crossOrigin', '');
      //url = url + '?' + new Date().getTime();
      // const urlInfo = urltool.parse(url);
      //
      // // Fixme: This URL should be optional
      // if (urlInfo.path.match(/^\/designer/)) {
      //   url = urlInfo.path + '?' + new Date().getTime();
      // } else {
      //   url = '/designer/proxy' + urlInfo.path + '?' + new Date().getTime();
      // }
    }

    //
    // hotfix: every image under proxy
    //
    if (process.env.NODE_ENV === 'production') {
      const urlInfo = urltool.parse(url);
      // Fixme: This URL should be optional
      if (urlInfo.path.match(/^\/designer/)) {
        url = urlInfo.path + '?' + new Date().getTime();
      } else {
        url = '/designer/proxy' + urlInfo.path + '?' + new Date().getTime();
      }
    }

    global.imageLoadingState.push(url);
    global.imageLoadingState = _uniq(global.imageLoadingState);

    img.onload = () => {
      console.log('Image loaded: ', img);
      this.setState({image: img});
      _remove(global.imageLoadingState, (v) => {
        return v === url;
      });
    };

    if (!img.src) {
      img.src = url;
    }
  }

  UNSAFE_componentWillMount() {
    this.load(this.props.src);
  }

  componentDidMount() {
    this.load(this.props.src);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.load(this.props.src);
    }
  }

  render() {
    //console.log(this.state);
    //if (!this.state.image) { return null;}
    return (
      <KonvaImage name={this.props.name} image={this.state.image} {...this.props.props} draggable={this.props.draggable || false} onTransformEnd={this.props.onTransformEnd} onDragEnd={this.props.onDragEnd}/>
    );
  }
}

export default CachedImage;



// WEBPACK FOOTER //
// ./src/components/CachedImage.js